import React from 'react';
import { Layout } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import StatsContent from './components/StatsContent';

import { ROLE } from '../services/Macro';
import { Global } from '../services/Global';
import { Page } from '../services/Page';
import { browserUtil } from '../utils/BrowserUtil';
import { checker } from '../utils/Checker';

const { Content } = Layout;

interface StatsViewState {
    loginName: string;
    showWarn: boolean;
    showConfirm: boolean;
    warnTitle: string;
    warnInfo: string;
    fileList: unknown[];
    appList: unknown[];
    confirmOp: () => void;
}

class StatsView extends React.Component<WithTranslation, StatsViewState> {
    state: StatsViewState = {
        loginName: '',
        showWarn: false,
        showConfirm: false,
        warnTitle: '本地错误',
        warnInfo: '参数错误',
        fileList: [],
        appList: [],
        confirmOp: () => console.log('do nothing!'),
    };

    componentDidMount = () => {
        Global.isMobile = browserUtil.checkMobile();
        console.log('进入统计管理页面时的登录校验');

        const callChecker = async () => {
            const isLogin = await checker.checkLogin(ROLE.SUPER, Page.stats);
            if (isLogin) {
                this.setState({ loginName: 'Admin' });
            }
        };
        callChecker();
    };

    openConfirm = (title: string, info: string, op: () => void) => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showConfirm: true,
            confirmOp: () => {
                op();
                this.closeConfirm();
            },
        });
    };

    closeConfirm = () => {
        this.setState({ showConfirm: false });
    };

    openWarn = (title: string, info: string) => {
        this.setState({
            warnTitle: title,
            warnInfo: info,
            showWarn: true,
        });
    };

    closeWarn = () => {
        this.setState({ showWarn: false });
    };

    changeLang = () => {
        // 保留原逻辑入口，语言切换由 Header/i18n 处理。
    };

    render() {
        const { t, i18n } = this.props;

        return (
            <Layout style={{ minHeight: '100vh' }}>
                <Header
                    trans={t}
                    i18n={i18n}
                    loginName={this.state.loginName}
                    changeLang={this.changeLang}
                />

                <Layout>
                    <Sidebar selectMenu="stats" trans={t} />
                    <Content>
                        <StatsContent
                            trans={t}
                            handleError={this.openWarn}
                            handleConfirm={this.openConfirm}
                            fileList={this.state.fileList}
                            appList={this.state.appList}
                        />
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export const StatsPage = withTranslation()(StatsView);
export default StatsView;
